import { render, staticRenderFns } from "./audit-add-or-update.vue?vue&type=template&id=45fcf0de&scoped=true"
import script from "./audit-add-or-update.vue?vue&type=script&lang=js"
export * from "./audit-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./audit-add-or-update.vue?vue&type=style&index=0&id=45fcf0de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fcf0de",
  null
  
)

export default component.exports